import { useLocation } from 'preact-iso';
import { useApi } from '../../hooks/useApi.js';
import { DeltaBadge } from '../../components/DeltaBadge.jsx';

const INK = '#34C77B';

// This-week headline KPIs with deltas vs last week. Links into the full page.
const ITEMS = [
  { key: 'issuesOpened', label: 'Issues opened', invert: true },
  { key: 'issuesResolved', label: 'Resolved', invert: false },
  { key: 'unitsConsumed', label: 'Units used', invert: true },
  { key: 'mixesSaved', label: 'Mixes saved', invert: false },
];

export const StatsWidget = () => {
  const { route } = useLocation();
  const { data } = useApi('/statistics/overview?range=this_week');
  const w = data?.windowed;

  return (
    <button
      onClick={() => route('/statistics')}
      class="block w-full rounded-md border border-border-subtle bg-bg-card p-4 text-left transition-colors hover:border-border-strong"
    >
      <div class="mb-3 flex items-center justify-between">
        <span class="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-eyebrow" style={{ color: INK }}>
          <span class="block h-2 w-2 rounded-full" style={{ background: INK }} />
          This week
        </span>
        <span class="text-xs text-text-muted">View statistics →</span>
      </div>
      <div class="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-4">
        {ITEMS.map((it) => {
          const kpi = w?.[it.key];
          return (
            <div key={it.key}>
              <p class="mb-1 text-[11px] uppercase tracking-label text-text-muted">{it.label}</p>
              <div class="flex items-baseline gap-2">
                <span class="font-serif text-[22px] font-medium leading-none text-text-primary">{kpi?.value ?? '—'}</span>
                {kpi && <DeltaBadge pct={kpi.deltaPct} invert={it.invert} />}
              </div>
            </div>
          );
        })}
      </div>
    </button>
  );
};
